import { cashDeskSchema } from "@/schemas/treasury";
import { useRestPaginatedQuery } from "../useRestPaginatedQuery";
import { querykeys } from "../constants";

/**
 * Caja (cashdesks) LIST: GET /api/v1/cashdesks -> { data, total }.
 * Un-paginated by default (hasPagination:false) and the records
 * (treasury_cash_desk_records) come EMBEDDED in each row, plus rel_user_open /
 * rel_user_close / rel_warehouse / rel_business (the BFF already excludes the
 * users' `password`). Ordered closedAt DESC by the BFF. Schema passthrough keeps
 * every Hasura relation key.
 */
function useGetCashDeskRest(
  operators: any = [],
  enabled: any = true,
  uniqueQuery: any = [],
  hasPagination: any = false
) {
  const { query, items, ...pagination } = useRestPaginatedQuery({
    queryKey: querykeys.cashDesk,
    url: "/api/v1/cashdesks",
    operators,
    enabled,
    uniqueQuery,
    hasPagination,
    itemSchema: cashDeskSchema,
  });

  return {
    cashDesk: query,
    items,
    ...pagination,
  };
}

export default useGetCashDeskRest;
